var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table timeline-details-content"},[_c('tbody',_vm._l((_vm.table.data),function(row){return _c('column-row',{key:row.$internalId,attrs:{"row":row,"columns":2},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_row = ref.row;
var attribute = ref_row.attribute;
var value = ref_row.value;
return [_c('td',{staticClass:"text-muted",attrs:{"width":"50%"}},[_c('attribute-name',{attrs:{"name":attribute}})],1),_c('td',[_c('attribute-value',{attrs:{"name":attribute,"value":value}})],1)]}}],null,true)})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }